export default __webpack_public_path__ + "static/img-project-8-aa68e6a9a70cca706dba49624a980762.png";